// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__pHdll","container":"styles_container__ijvwi","slide":"styles_slide__8_a24"};